import { recalculateConflicts } from '@editor2/reducers/editor/editorSlice';
import { type RootState } from '@editor2/reducers/root';
import { type FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Global component that listens to the store updates and dispatches
// conflicts recalculation (if unresolved conflicts are present)

interface Props {
	courseId: number;
}

const ConflictUpdate: FC<Props> = (props) => {
	const { courseId } = props;

	const { book, chapters, page_groups, pages, elements, conflicts } = useSelector(
		(state: RootState) => state.courses[courseId]
	);

	const dispatch = useDispatch();

	useEffect(() => {
		if (conflicts.length) dispatch(recalculateConflicts({ courseId }));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [book, chapters, page_groups, pages, elements]);

	return <></>;
};

export default ConflictUpdate;
